import React from "react";

import { TextField } from "@material-ui/core";

import { OutlinedSelectProps } from "./types";

const OutlinedSelect: React.FC<OutlinedSelectProps> = ({
  children,
  ...rest
}) => (
  <TextField select variant="outlined" {...rest}>
    {children}
  </TextField>
);

export default OutlinedSelect;
